import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import AdminHomepage from '../AdminPage/Homepage/adminHomePage';
import EditorToolbar from '../AdminPage/Toolbar/EditorToolbar';
import AdminToolbar from '../AdminPage/Toolbar/AdminToolbar';
import NMH_LOGO_White_RGB from '../Assets/NMH_LOGO_White_RGB.png';
import UserHomepageview from '../User/userHomepage';
import UserToolbar from '../User/UserToolbar';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const HomepageWrapper = () => {
  const navigate = useNavigate();
  const [userType, setUserType] = useState(null);
  const [username, setUsername] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getUserFromCookie = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/api/isLoggedIn`, {
          withCredentials: true,
        });
        const { user, username } = res.data;
        if (username && (user === 'Admin' || user === 'Editor' || user === 'User')) {
          setUserType(user);
          setUsername(username);
        } else {
          navigate('/');
        }
      } catch (err) {
        console.error('Error checking login:', err);
        navigate('/');
      } finally {
        setLoading(false);
      }
    };

    getUserFromCookie();
  }, [navigate]);

  if (loading) return <p>Loading...</p>;

  return (
    <>
     
      {userType === 'Admin' && (
            <>
            <AdminToolbar/>
             <AdminHomepage/>
            </>
          )}
      {userType === 'Editor' && (
            <>
            <EditorToolbar/>
            <AdminHomepage/>
            </>
          )}
          {userType === 'User' && (
            <>
            <UserToolbar/>
            <UserHomepageview/>
            </>
          )}
   
    </>
  );
};

export default HomepageWrapper;
